import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useMytaverse } from '@providers/MytaverseProvider';
import { useMytaverseEvent } from '../../../../providers';

import { WebsocketAction } from '@interfaces/webSocketConnectionInfo';
import { useCommunications } from '@core/communications/providers/CommunicationsProvider';

export const useAdminTools = () => {
  const [editing, setEditing] = useState(false);
  const [isDroneMode, setIsDroneMode] = useState(false);
  const { t: translate } = useTranslation();
  const { sendMessageToUnreal, sendMessageToEvent } = useMytaverse();
  const { conferenceName } = useCommunications();

  const { setOpenAdminSettingsModal, currentEvent, currentParticipant } =
    useMytaverseEvent();
  const handleCreatePOIs = () => {
    sendMessageToUnreal({
      action: editing
        ? WebsocketAction.StopPoiCreatingMode
        : WebsocketAction.StartPoiCreatingMode,
    });
    setEditing(!editing);
  };

  const handleDroneMode = useCallback(() => {
    const unrealAction = isDroneMode
      ? WebsocketAction.DisableDroneCamera
      : WebsocketAction.EnableDroneCamera;

    setIsDroneMode(!isDroneMode);
    sendMessageToUnreal({
      action: unrealAction,
    });
  }, [isDroneMode, sendMessageToUnreal]);

  const handleMuteAll = useCallback(() => {
    if (!currentEvent || !currentParticipant) {
      return;
    }
    sendMessageToEvent(currentEvent.eventId, {
      action: WebsocketAction.MuteConference,
      mutedBy: currentParticipant.participantId,
      conferenceId: conferenceName,
    });
  }, [currentEvent, currentParticipant, sendMessageToEvent, conferenceName]);

  const handleLevelEditor = useCallback(() => {
    sendMessageToUnreal({
      action: WebsocketAction.ToggleLevelEditor,
    });
  }, []);

  const handleOpenAdminSettings = () => {
    setOpenAdminSettingsModal(true);
  };

  return {
    editing,
    setEditing,
    translate,
    handleCreatePOIs,
    handleDroneMode,
    handleOpenAdminSettings,
    handleMuteAll,
    handleLevelEditor,
  };
};
